import React from "react";
import { Typography } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
const { Title, Text } = Typography;

export const HelpCollectionEligibility = () => {
  return (
    <>
      <Title level={5}>
        <QuestionCircleOutlined />
        &nbsp;Configuring your Service Collection Eligibility Settings
      </Title>
      <ul>
        <li>
          <Text type="danger">Eligibile Role (Mandatory):</Text> Role used for
          Eligible people. People with this role will be Eligible to subscribe
          to the Collection, then access to Applications and optionally own
          Resources.
        </li>

        <li>
          <Text>Eligible with Approval Role:</Text> This Role contains people
          allowed to request access to the collection, after being approved by a
          supervisor and/or service desk.
          <br />
          People with this role will be able to click <i>Request</i> button to
          create a moderated request to be added to the group specified in{" "}
          <i>Eligible with Approval Group</i> below.
        </li>
        <li>
          <Text>Eligible with Approval Group:</Text> This (moderated) group will
          contains people who requested access to the Collection, and were
          approved by a supervisor.
          <br />
          Note: This group must be member of the <i>Subscribed Role</i> below.
        </li>

        <li>
          <Text type="danger">Subscribed Role (Mandatory):</Text> Role used for
          Subscribed people. People with this role will be subscribed to the
          Collection.
        </li>

        <li>
          <Text>Self Subscription Group:</Text> The group belonging to the
          Subscribed Role where people will be self-added when clicking
          Subscribe button.
          <br />
          If not set, users not in the Subscribed Role will not be able to
          Subscribe to the Service.
        </li>
        <li>
          <Text type="secondary">Admin RoleId:</Text> People with admin rights
          to this Collection.
        </li>
      </ul>
    </>
  );
};
